var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _linearGradient, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1993.481 1947.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#881421",
    d: "M463.6 1251.72v463.6c0 128 342.462 231.8 764.94 231.8s764.94-103.8 764.94-231.8v-463.6H463.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AF2031",
    d: "M463.6 741.76v509.96c0 128 342.462 231.8 764.94 231.8s764.94-103.8 764.94-231.8V741.76H463.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C94F60",
    d: "M463.6 231.8v509.96c0 128 342.462 231.8 764.94 231.8s764.94-103.8 764.94-231.8V231.8H463.6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1228.541,
    cy: 231.8,
    fill: "#E08095",
    rx: 764.94,
    ry: 231.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.662 417.24H463.6v1159h564.062c46.869-.153 84.825-38.109 84.978-84.978V502.218c-.152-46.869-38.109-84.825-84.978-84.978z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M981.302 463.6H463.6v1159h517.702c46.869-.153 84.825-38.109 84.978-84.978V548.578c-.152-46.869-38.109-84.825-84.978-84.978z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M981.302 463.6H463.6v1066.28h517.702c46.869-.153 84.825-38.109 84.978-84.978V548.578c-.152-46.869-38.109-84.825-84.978-84.978z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M934.943 463.6H463.6v1066.28h471.342c46.869-.153 84.825-38.109 84.978-84.978V548.578c-.152-46.869-38.109-84.825-84.977-84.978z",
    opacity: 0.2
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 177.1808,
    x2: 842.7396,
    y1: 1551.9205,
    y2: 399.2002,
    gradientTransform: "matrix(1 0 0 -1 0 1949.1207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b72c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b12334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d1623"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M84.978 463.6h849.965c46.932 0 84.978 38.046 84.978 84.978v849.964c0 46.932-38.046 84.978-84.978 84.978H84.978C38.046 1483.52 0 1445.474 0 1398.542V548.578C0 501.646 38.046 463.6 84.978 463.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M448.904 697.301h125.172l201.11 552.472H656.968l-44.32-131.755H405.743l-43.532 131.755H244.735l204.169-552.472zm137.133 335.6L521.736 832.95c-5.257-14.656-9.198-29.752-11.775-45.108h-2.318c-2.39 15.78-6.255 31.302-11.544 46.36l-64.904 198.792 154.842-.093z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.fb91d2e2474c5a0164f5d8224b45d865.svg";
export { ForwardRef as ReactComponent };